import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ServerService} from "../../../../src/app/services/ServerService";

@Injectable({
  providedIn: 'root'
})
export class CountryService extends   ServerService {
  constructor(http: HttpClient) {
    super(http)
  }

  getCountries() {
    return this.http.get('/countries/'  , {})
      .toPromise();

  }
}
